import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from '../components/PrivateRoute';
import Privacy from '../pages/PrivacyPage';

// 페이지
import DashboardPage from '../pages/DashboardPage';
import MapPage from '../pages/MapPage';
import UserPage from '../pages/UserPage';
import DevicePage from '../pages/DevicePage';
import AdminPage from '../pages/AdminPage';
import LoginPage from '../pages/LoginPage';
import LogPage from '../pages/LogPage';
import UserQna from '../pages/UserQna';
import UserSign from '../pages/UserSign';
import UserProtected from '../pages/UserProtected';
import AppDownloadPage from '../pages/AppDownloadPage';

// 사용자 관리
import UserDetail from '../components/user/UserDetail';
import UserWrite from '../components/user/UserWrite';
import UserFamily from '../components/user/UserFamily';
import UserEdit from '../components/user/UserEdit';
import UserFamilyEdit from '../components/user/UserFamilyEdit';
import UserAlertEdit from '../components/user/UserAlertEdit';
import UserAlertAdd from '../components/user/UserAlertAdd';

// 장비 관리
import DeviceWrite from '../components/device/DeviceWrite';
import DeviceDetail from '../components/device/DeviceDetail';
import DeviceEdit from '../components/device/DeviceEdit';

// 관리자 관리
import AdminWrite from '../components/admin/AdminWrite';
import AdminDetail from '../components/admin/AdminDetail';
import AdminEdit from '../components/admin/AdminEdit';
import Department from '../components/admin/DepartmentPlus';

//문의사항
import AdminQna from '../pages/AdminQna';
import AdminQnaDetail from "../components/qna/adminqnadetail";

export default function Router() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/userqna" element={<UserQna />} />
	  <Route path="/usersign" element={<UserSign />} />
	  <Route path="/userprotected" element={<UserProtected />} />
      <Route path="/app-download/:platform" element={<AppDownloadPage />} />

      {/* 로그인 해야 접근 가능한 페이지들 */}
      <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
      <Route path="/map" element={<PrivateRoute><MapPage /></PrivateRoute>} />

      {/* 사용자 관리 */}
      <Route path="/user" element={<PrivateRoute><UserPage /></PrivateRoute>} />
      <Route path="/user/:id" element={<PrivateRoute><UserDetail /></PrivateRoute>} />
      <Route path="/user/new" element={<PrivateRoute><UserWrite /></PrivateRoute>} />
      <Route path="/user/new/family" element={<PrivateRoute><UserFamily /></PrivateRoute>} />
      <Route path="/user/edit" element={<PrivateRoute><UserEdit /></PrivateRoute>} />
      <Route path="/user/edit/family" element={<PrivateRoute><UserFamilyEdit /></PrivateRoute>} />
      <Route path="/user/alert/edit" element={<PrivateRoute><UserAlertEdit /></PrivateRoute>} />
      <Route path="/user/alert/new" element={<PrivateRoute><UserAlertAdd /></PrivateRoute>} />

      {/* 장비 관리 */}
      <Route path="/device" element={<PrivateRoute><DevicePage /></PrivateRoute>} />
      <Route path="/device/new" element={<PrivateRoute><DeviceWrite /></PrivateRoute>} />
      <Route path="/device/:id" element={<PrivateRoute><DeviceDetail /></PrivateRoute>} />
      <Route path="/device/edit" element={<PrivateRoute><DeviceEdit /></PrivateRoute>} />

      {/* 관리자 */}
      <Route path="/admin" element={<PrivateRoute><AdminPage /></PrivateRoute>} />
      <Route path="/admin/new" element={<PrivateRoute><AdminWrite /></PrivateRoute>} />
      <Route path="/admin/:id" element={<PrivateRoute><AdminDetail /></PrivateRoute>} />
      <Route path="/admin/edit" element={<PrivateRoute><AdminEdit /></PrivateRoute>} />
      <Route path="/admin/department" element={<PrivateRoute><Department /></PrivateRoute>} />
      
      {/* 로그관리 */}
      <Route path="/log" element={<PrivateRoute><LogPage /></PrivateRoute>} />

      {/* 문의사항 */}
      <Route path="/adminqna" element={<PrivateRoute><AdminQna /></PrivateRoute>} />
      <Route path="/adminqna/:id" element={<PrivateRoute><AdminQnaDetail /></PrivateRoute>} />

    </Routes>
  );
}
